interface TextPageLayoutProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}

export function TextPageLayout({ title, subtitle, children }: TextPageLayoutProps) {
  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div className="space-y-2">
        <h1 className="page-heading text-2xl sm:text-3xl font-semibold tracking-tight">{title}</h1>
        <p className="text-sm text-muted-foreground">{subtitle}</p>
      </div>

      <div className="prose prose-sm sm:prose-base max-w-none">
        <div className="text-foreground space-y-4">
          {children}
        </div>
      </div>
    </div>
  );
}

